import Joi from 'joi';

import { FileSensitivityEnum } from '../../enums/file-sensitivity.enum';

/**
 * Schema for record validation.
 * @description This schema is used to validate the record properties when creating or updating the record.
 */
export const fileSchema = () =>
	Joi.object({
		// Uuid
		uuid: Joi.alternatives().conditional(Joi.any().valid(null), {
			then: Joi.invalid(null).messages({
				'any.invalid': 'validations|file-uuid|cannot-be-null',
			}),
			otherwise: Joi.string().required().messages({
				'any.required': 'validations|file-uuid|required',
				'string.base': 'validations|file-uuid|must-be-string',
				'string.empty': 'validations|file-uuid|must-not-be-empty',
			}),
		}),

		// Name
		name: Joi.alternatives().conditional(Joi.any().valid(null), {
			then: Joi.invalid(null).messages({
				'any.invalid': 'validations|file-name|cannot-be-null',
			}),
			otherwise: Joi.string().required().messages({
				'any.required': 'validations|file-name|required',
				'string.base': 'validations|file-name|must-be-string',
				'string.empty': 'validations|file-name|must-not-be-empty',
			}),
		}),

		// Size
		size: Joi.any().required().messages({
			// 'number.base': 'validations|file-size|must-be-numeric',
			// 'number.greater':
			// 	'validations|file-size|must-be-greater-than-zero',
			'any.required': 'validations|file-size|required',
		}),

		// Mime type
		mimeType: Joi.alternatives().conditional(Joi.any().valid(null), {
			then: Joi.invalid(null).messages({
				'any.invalid': 'validations|file-mime-type|cannot-be-null',
			}),
			otherwise: Joi.string().required().messages({
				'any.required': 'validations|file-mime-type|required',
				'string.base': 'validations|file-mime-type|must-be-string',
				'string.empty': 'validations|file-mime-type|must-not-be-empty',
			}),
		}),

		// Sensitivity
		sensitivity: Joi.string()
			.valid(...Object.values(FileSensitivityEnum))
			.required()
			.messages({
				'any.required': 'validations|file-sensitivity|required',
				'any.only': 'validations|file-sensitivity|invalid-value',
			}),
	})
		// Ignore extra fields
		.unknown();
